<template>
  <div class="row-button-card">
    <div class="row-button-card_content">
      <p
        v-if="title"
        class="row-button-card_content-title"
      >
        {{ title }}
      </p>
      <p
        v-if="contentText"
        class="row-button-card_content-text"
      >
        {{ contentText }}
      </p>
    </div>
    <div class="row-button-card_button">
      <slot name="btn" />
    </div>
  </div>
</template>
<script>
export default {
  name: "RowButtonCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    contentText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/row-button-card";
</style>